export enum SkuAnnotationArrowhead {
	None = 'none',
	Start = 'start',
	End = 'end',
	Both = 'both'
}
